import React from 'react'
import { useTranslation } from 'react-i18next'
import { MyDayContent } from '../my-day/MyDayContent'
import { usePermissions } from '../../hooks/usePermissions'
import { getAppLocale } from '../../i18n'
import { formatFieldDate } from '../../i18n/localeFormat'

/** Field-worker home: greeting + full My Day (clock / jobs / complete). */
export function CrewHomeDashboard() {
  const { t } = useTranslation('field')
  const { profile } = usePermissions()
  const locale = getAppLocale()
  const todayLabel = formatFieldDate(new Date(), locale, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  })
  const firstName =
    profile?.first_name?.trim() || profile?.email?.split('@')[0] || ''

  return (
    <MyDayContent
      title={firstName ? t('helloName', { name: firstName }) : t('helloNoName')}
      subtitle={todayLabel}
    />
  )
}
